import { createFiltersContext } from "@amphore-dev/amphore-lib";

import { TFilters } from "@/types";

export const { Provider: FiltersProvider, useFiltersContext } =
	createFiltersContext<TFilters>();
